export class AmericanStates {
    public static readonly 'Alabama' = 'Alabama';
    public static readonly 'Alaska' = 'Alaska';
    public static readonly 'Arizona' = 'Arizona';
    public static readonly 'Arkansas' = 'Arkansas';
    public static readonly 'California' = 'California';
    public static readonly 'Colorado' = 'Colorado';
    public static readonly 'Connecticut' = 'Connecticut';
    public static readonly 'Delaware' = 'Delaware';
    public static readonly 'District of Columbia (D.C.)' = 'District of Columbia (D.C.)';
    public static readonly 'Florida' = 'Florida';
    public static readonly 'Georgia' = 'Georgia';
    public static readonly 'Hawaii' = 'Hawaii';
    public static readonly 'Idaho' = 'Idaho';
    public static readonly 'Illinois' = 'Illinois';
    public static readonly 'Indiana' = 'Indiana';
    public static readonly 'Iowa' = 'Iowa';
    public static readonly 'Kansas' = 'Kansas';
    public static readonly 'Kentucky' = 'Kentucky';
    public static readonly 'Louisiana' = 'Louisiana';
    public static readonly 'Maine' = 'Maine';
    public static readonly 'Maryland' = 'Maryland';
    public static readonly 'Massachusetts' = 'Massachusetts';
    public static readonly 'Michigan' = 'Michigan';
    public static readonly 'Minnesota' = 'Minnesota';
    public static readonly 'Mississippi' = 'Mississippi';
    public static readonly 'Missouri' = 'Missouri';
    public static readonly 'Montana' = 'Montana';
    public static readonly 'Nebraska' = 'Nebraska';
    public static readonly 'Nevada' = 'Nevada';
    public static readonly 'New Hampshire' = 'New Hampshire';
    public static readonly 'New Jersey' = 'New Jersey';
    public static readonly 'New Mexico' = 'New Mexico';
    public static readonly 'New York' = 'New York';
    public static readonly 'North Carolina' = 'North Carolina';
    public static readonly 'North Dakota' = 'North Dakota';
    public static readonly 'Ohio' = 'Ohio';
    public static readonly 'Oklahoma' = 'Oklahoma';
    public static readonly 'Oregon' = 'Oregon';
    public static readonly 'Pennsylvania' = 'Pennsylvania';
    public static readonly 'Rhode Island' = 'Rhode Island';
    public static readonly 'South Carolina' = 'South Carolina';
    public static readonly 'South Dakota' = 'South Dakota';
    public static readonly 'Tennessee' = 'Tennessee';
    public static readonly 'Texas' = 'Texas';
    public static readonly 'Utah' = 'Utah';
    public static readonly 'Vermont' = 'Vermont';
    public static readonly 'Virginia' = 'Virginia';
    public static readonly 'Washington' = 'Washington';
    public static readonly 'West Virginia' = 'West Virginia';
    public static readonly 'Wisconsin' = 'Wisconsin';
    public static readonly 'Wyoming' = 'Wyoming';
}

export class AmericanStateAbbreviations {
    public static readonly 'Alabama' = 'AL';
    public static readonly 'Alaska' = 'AK';
    public static readonly 'Arizona' = 'AZ';
    public static readonly 'Arkansas' = 'AR';
    public static readonly 'California' = 'CA';
    public static readonly 'Colorado' = 'CO';
    public static readonly 'Connecticut' = 'CT';
    public static readonly 'Delaware' = 'DE';
    public static readonly 'District of Columbia (D.C.)' = 'DC';
    public static readonly 'Florida' = 'FL';
    public static readonly 'Georgia' = 'GA';
    public static readonly 'Hawaii' = 'HI';
    public static readonly 'Idaho' = 'ID';
    public static readonly 'Illinois' = 'IL';
    public static readonly 'Indiana' = 'IN';
    public static readonly 'Iowa' = 'IA';
    public static readonly 'Kansas' = 'KS';
    public static readonly 'Kentucky' = 'KY';
    public static readonly 'Louisiana' = 'LA';
    public static readonly 'Maine' = 'ME';
    public static readonly 'Maryland' = 'MD';
    public static readonly 'Massachusetts' = 'MA';
    public static readonly 'Michigan' = 'MI';
    public static readonly 'Minnesota' = 'MN';
    public static readonly 'Mississippi' = 'MS';
    public static readonly 'Missouri' = 'MO';
    public static readonly 'Montana' = 'MT';
    public static readonly 'Nebraska' = 'NE';
    public static readonly 'Nevada' = 'NV';
    public static readonly 'New Hampshire' = 'NH';
    public static readonly 'New Jersey' = 'NJ';
    public static readonly 'New Mexico' = 'NM';
    public static readonly 'New York' = 'NY';
    public static readonly 'North Carolina' = 'NC';
    public static readonly 'North Dakota' = 'ND';
    public static readonly 'Ohio' = 'OH';
    public static readonly 'Oklahoma' = 'OK';
    public static readonly 'Oregon' = 'OR';
    public static readonly 'Pennsylvania' = 'PA';
    public static readonly 'Rhode Island' = 'RI';
    public static readonly 'South Carolina' = 'SC';
    public static readonly 'South Dakota' = 'SD';
    public static readonly 'Tennessee' = 'TN';
    public static readonly 'Texas' = 'TX';
    public static readonly 'Utah' = 'UT';
    public static readonly 'Vermont' = 'VT';
    public static readonly 'Virginia' = 'VA';
    public static readonly 'Washington' = 'WA';
    public static readonly 'West Virginia' = 'WV';
    public static readonly 'Wisconsin' = 'WI';
    public static readonly 'Wyoming' = 'WY';
}

export const AmericanStateOptions = Object.keys(AmericanStates).map((state) => ({
    label: AmericanStates[state],
    value: AmericanStateAbbreviations[state]
}));

export class AmericanTerritories {
    public static readonly 'Guam' = 'Guam';
    public static readonly 'Puerto Rico' = 'Puerto Rico';
    public static readonly 'US Virgin Islands' = 'US Virgin Islands';
}

export const AmericanTerritoriesOptions = Object.keys(AmericanTerritories).map((state) => ({
    label: AmericanTerritories[state],
    value: state
}));

export const AmericanStatesAndTerritoriesOptions = [
    ...AmericanStateOptions,
    ...AmericanTerritoriesOptions
].sort((option1: any, option2: any): number => {
    if (option1.label < option2.label) {
        return -1;
    }
    if (option1.label > option2.label) {
        return 1;
    }
    return 0;
});

export class CanadianProvinces {
    public static readonly 'Alberta' = 'AB';
    public static readonly 'British Columbia' = 'BC';
    public static readonly 'Manitoba' = 'MB';
    public static readonly 'New Brunswick' = 'NB';
    public static readonly 'Newfoundland And Labrador' = 'NL';
    public static readonly 'Nova Scotia' = 'NS';
    public static readonly 'Ontario' = 'ON';
    public static readonly 'PrinceEdward Island' = 'PE';
    public static readonly 'Quebec' = 'QC';
    public static readonly 'Saskatchewan' = 'SK';
}

export const CanadianProvincesOptions = Object.keys(CanadianProvinces).map((province) => ({
    label: CanadianProvinces[province],
    value: province
}));
